import { useEffect, useMemo, useRef } from "react";
import { useDoorCatalog, useProfileSystems } from "../../lib/catalog";

// Bij deze keuzes tonen we alle profielsystemen; anders alleen systemen die bij het product horen.
const OPEN_PRODUCTS = ["meerdere_kozijnen", "anders"];

// Neemt deur (?deur=), kleur (?kleur=), glasuitvoering (?glas=) en profielsysteem (?systeem=) over in de wizard.
export const useWizardCatalog = (form, setForm, params) => {
  const { doors, options } = useDoorCatalog();
  const systems = useProfileSystems();
  const opts = useMemo(() => Object.fromEntries(options.map((o) => [o.id, o])), [options]);
  const doneDoor = useRef(false);
  const doneSystem = useRef(false);

  useEffect(() => {
    if (doneDoor.current || !params.deur || !doors.length) return;
    doneDoor.current = true;
    const d = doors.find((x) => x.id === params.deur);
    if (!d) return;
    const color = d.colors.includes(params.kleur) ? opts[params.kleur]?.label : null;
    const glassType = d.glass_options.includes(params.glas) ? opts[params.glas]?.label : null;
    setForm((f) => ({ ...f, door_model: d.id, product: `${d.material}_deur`, door_glass: f.door_glass || (d.has_glass ? "ja" : "nee"),
      color: color || f.color, door_glass_type: glassType || f.door_glass_type }));
  }, [doors, opts, params.deur, params.kleur, params.glas, setForm]);

  useEffect(() => {
    if (doneSystem.current || !params.systeem || !systems.length) return;
    doneSystem.current = true;
    if (systems.some((s) => s.slug === params.systeem)) setForm((f) => ({ ...f, profile_system: params.systeem }));
  }, [systems, params.systeem, setForm]);

  const raw = doors.find((x) => x.id === form.door_model);
  useEffect(() => {
    if (raw && form.product !== `${raw.material}_deur`) setForm((f) => ({ ...f, door_model: null, door_glass_type: null }));
  }, [raw, form.product, setForm]);
  const door = raw && { ...raw, colorLabels: raw.colors.map((i) => opts[i]?.label).filter(Boolean),
    glassLabels: raw.glass_options.map((i) => opts[i]?.label).filter(Boolean) };
  const open = !form.product || OPEN_PRODUCTS.includes(form.product);
  const systemOptions = systems.filter((s) => open || s.product_keys.includes(form.product)).map((s) => ({ id: s.slug, label: s.name }));
  return { door, systemOptions };
};
